import {gql} from '@apollo/client';
import {useMutation$} from "../../../graphqlsupport";

export const SYNC_CLIENT_REPORTS_BY_OPERATION_CASE = gql`
    mutation syncClientReportsByOperationCase($sfOperationCaseId: String!) {
        syncClientReportsByOperationCase(sfOperationCaseId: $sfOperationCaseId) {
            guid
            reportStatus
            sfOperationCaseRptStatus
            authorizedDate
            authorizedBy
            sfCloseReason
            sfCloseDate
            sfLastModifiedDate
        }
    }
`;

type SyncClientReportsByOperationCaseInput = {
    sfOperationCaseId: string;
}

type SyncClientReportsByOperationCaseResult = {
    syncClientReportsByOperationCase: {
        guid: string;
        reportStatus: string;
        sfOperationCaseRptStatus: string;
        authorizedDate: string;
        authorizedBy: string;
        sfCloseReason: string;
        sfCloseDate: string;
        sfLastModifiedDate: string;
    }
}

export const useSyncClientReportsByOperationCase = () => {
    const {
        isRunning$,
        execute,
    } = useMutation$<SyncClientReportsByOperationCaseInput, SyncClientReportsByOperationCaseResult>(SYNC_CLIENT_REPORTS_BY_OPERATION_CASE);

    return {
        isRunning$,
        execute,
    };
};
